import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppStakeholderService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppStakeholders`);
    }
}
